import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AllActionsUnion } from 'src/app/app.actions';
import { LoadingState } from '../restaurant/restaurant.reducer';
import { updateLoadingState } from './withdraw.actions';

export interface WithdrawState {
  loadingState: LoadingState;
}

const initialState: WithdrawState = {
  loadingState: 'none',
};

export const featureName = 'withdrawFeature';

export function withdrawReducer(
  state_: WithdrawState | undefined,
  action: AllActionsUnion,
): WithdrawState {
  const reducer_ = createReducer<WithdrawState>(
    initialState,
    on(
      updateLoadingState,
      (state, { payload }): WithdrawState => {
        return { ...state, loadingState: payload };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<WithdrawState>(featureName);

export const getLoadingState = pipe(
  select(
    createSelector(
      getFeature,
      v => v.loadingState,
    ),
  ),
  distinctUntilChanged(),
);
